import { render, staticRenderFns } from "./IconAndroid.vue?vue&type=template&id=439f5507&"
import script from "./IconAndroid.vue?vue&type=script&lang=js&"
export * from "./IconAndroid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports